import React from 'react';
import AutocompleteController, { AutocompleteControllerProps } from './AutocompleteController';

type EntityAutocompleteProps = Omit<AutocompleteControllerProps, 'notOnlyRef'>;

export default (props: EntityAutocompleteProps) => {
    return <AutocompleteController {...props} returnObjectAsValue />;
};
